import { isApolloError, ServerParseError } from '@apollo/client';
import { Button } from 'components';
import SimplePageLayout from 'components/SimplePageLayout';
import colors from 'lib/colors';
import { Trans, useTranslation } from 'react-i18next';

interface Props {
  error?: Error;
  eventId?: string | null;
  onRetry?: () => void;
  retryButtonLabel?: string;
}

const ErrorPage = ({ eventId, onRetry, error, retryButtonLabel }: Props) => {
  const [t] = useTranslation();
  let header = t('errorPage.header', 'Jejda');
  let body: React.ReactNode = t('errorPage.body', 'Bohužel se stala chyba :(');
  if (error != null && isApolloError(error)) {
    const { networkError, graphQLErrors } = error;
    if (networkError) {
      const statusCode: number | undefined = (networkError as ServerParseError)
        .statusCode;
      if (statusCode != null && statusCode > 500) {
        header = t('errorPage.maintenance.header', 'Za chvíli jsme zpět');
        body = (
          <Trans t={t} i18nKey="errorPage.maintenance.body">
            Právě aktualizujeme naše servery a nejsou dostupné.
            <br />
            Děkujeme za trpělivost
          </Trans>
        );
      } else {
        body = t('general.connectionError');
      }
    } else if (graphQLErrors.length) {
      const err = graphQLErrors[0];
      body = t('general.serverError', { err });
    }
  }
  return (
    <SimplePageLayout>
      <h1 css={{ color: colors.white }}>{header}</h1>
      <p css={{ color: colors.sunriseViolet, lineHeight: 1.35 }}>{body}</p>
      {eventId != null && (
        <p css={{ color: colors.sunriseViolet }}>
          {t('errorPage.eventId', 'ID Chyby: {{eventId}}', { eventId })}
        </p>
      )}
      {onRetry != null && (
        <Button
          css={{ marginTop: '0.67em' }}
          label={retryButtonLabel || t('errorPage.retryButton', 'Zkusit znovu')}
          onClick={onRetry}
          variant="warning"
        />
      )}
    </SimplePageLayout>
  );
};

export default ErrorPage;
